import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Containers/LoginPage/LoginPage";
import ProtectedRoute from "./Utils/ProtectedRoutes";
import AdminLayout from "./Components/Layout/AdminLayout";
import routes from "./Utils/routes";
import useHtpp from "./Utils/useHttps";
import { useEffect, useState } from "react";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const { configureHeaders, configureInterceptors } = useHtpp();
  useEffect(() => {
    configureHeaders();
    configureInterceptors();
  }, [configureHeaders, configureInterceptors]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/login"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />

        <Route
          path="/*"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <AdminLayout>
                <Routes>
                  {(() => {
                    const getAllRoutes = (items) => {
                      return items.reduce((acc, item) => {
                        if (item.path && item.element) {
                          acc.push(
                            <Route
                              key={item.path}
                              path={item.path}
                              element={<item.element />}
                            />
                          );
                        }
                        if (item.children) {
                          acc.push(...getAllRoutes(item.children));
                        }
                        return acc;
                      }, []);
                    };
                    return getAllRoutes(routes);
                  })()}
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
